// Select donation type
// Makes sure the correct type is sent with the form and the
// preselected values in the admin are initially selected for each type
// ----------------------------------------------------------------

import $ from 'jquery';

const donationTypeInput = $('.c-form input[name="donation-type"]');
const donationTypeOutput = $('#donation_type');
const donationAmountInput = $('.c-form input[name="donation-amount"]')

const mobilePayButton = $('#button-mobilepay')

function updatePreselected(event) {
    const donationType = $(event.target).val()

    if (donationAmountInput.hasClass(`js-preselect--${donationType}`)) {
        $(`.c-form .js-preselect--${donationType}`).first().trigger('click');
    }
}

$(donationTypeInput).on('input click', (event) => {
    const value = $(event.target).val()
    $(donationTypeOutput).val(value);

    if (value === 'single') {
        mobilePayButton.show()
    } else {
        mobilePayButton.hide()
    }
});

$(document).on('click', '.c-form input[name="donation-type"]', updatePreselected)

donationAmountInput.on('click', function(event) {
    if (! event.originalEvent) {
        // not a user click, caused by trigger() from updatePreselected
        return;
    }
    $(document).off('click', '.c-form input[name="donation-type"]', updatePreselected)
})

function init() {
    donationTypeInput.each(function() {
        if (this.hasAttribute('checked')) {
            const donationType = $(this).val();

            // Seemingly in some cases not all items would be clicked, maybe depending
            // if there are multiple forms on a page or not. A timeout seems to help.
            setTimeout(() => {
                // trigger 'donationFormPaymentMethod' function in select-donation-amount.js
                // to update the payment type texts
                $(this).trigger('click');

                $(`.c-form .js-preselect--${donationType}`).trigger('click');
            }, 250);
        }
    })
}

$('.c-form').on('reset', function() {
    // hacky way to execute init() after form reset event completes
    setTimeout(() => {init()}, 100)
})

init()
